import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TimeAgo from 'timeago-react'
import ReactMarkdown from 'react-markdown'

import {decrypt} from 'utils/encryption.utils'
import AnimatedLock from 'components/AnimatedLock'

import styles from './styles.module.scss'

const Message = ({
  keyManager,
  createdAt,
  message,
  messageNode,
  from,
  isFromSelf,
}) => {
  const [decryptedMessage, setDecryptedMessage] = useState(null)

  useEffect(() => {
    if (!keyManager || !message) return

    async function setMessage() {
      try {
        const msg = await decrypt({keyManager, armored: message})
        setDecryptedMessage(msg)
      } catch (err) {
        // @TODO: handle decryption errors
      }
    }
    setMessage()
  }, [keyManager, message])

  return (
    <div
      className={classNames(styles.messageContainer, {
        [styles.messageFromSelfContainer]: isFromSelf,
      })}>
      <div
        className={classNames('is-size-6 is-size-7-mobile', styles.message, {
          [styles.messageFromSelf]: isFromSelf,
          'has-text-white': isFromSelf,
          'has-background-dark': isFromSelf,
          'has-text-dark': !isFromSelf,
          'has-background-white': !isFromSelf,
        })}>
        {!messageNode ? (
          decryptedMessage !== null ? (
            <ReactMarkdown
              className="content"
              source={decryptedMessage}
              linkTarget="_blank"
              disallowedTypes={['heading']}
              unwrapDisallowed
            />
          ) : (
            <div className="has-text-centered">
              <span className="icon has-text-success">
                <AnimatedLock isClosed isLoading />
              </span>
            </div>
          )
        ) : (
          messageNode
        )}
      </div>
      <div
        className={classNames('is-size-7 has-text-grey-light', {
          'has-text-right': isFromSelf,
          'has-text-left': !isFromSelf,
        })}>
        {createdAt && <TimeAgo datetime={createdAt} opts={{minInterval: 60}} />}{' '}
        {from && `~ ${from}`}
      </div>
    </div>
  )
}

Message.propTypes = {
  createdAt: PropTypes.number,
  from: PropTypes.string,
  isFromSelf: PropTypes.bool,
  keyManager: PropTypes.object,
  message: PropTypes.string,
  messageNode: PropTypes.node,
}

export default Message
